import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { NutritionAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-nutrition-slot',
    templateUrl: './nutrition-slot.component.html',
    styleUrl: './nutrition-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NutritionSlotComponent implements SheetSlotComponentBase {

	action!: NutritionAction;
	value!: string | null;

	@Input('action') set updateAction(action: NutritionAction | null) {
		this.action = action as NutritionAction;
		this.value = this.action.amountGiven?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}